export const permissions = Object.freeze({
    create_sample_orders_permissions: ["orders.add_sampleorders"],
    sample_orders_permissions: ["orders.view_sampleorderitems_list"],
    customize_sample_order_permissions: ["orders.view_sampleorders"],
    sample_invoice_permissions: ["orders.view_sampleorders"],

    create_orders_permissions: ["orders.add_orders"],
    customer_orders_permissions: ["orders.view_orders_list"],
    customize_order_permissions: ["orders.view_orders"],
    customer_order_invoice_permissions: ["orders.view_orders"],
    single_customer_orders_permissions: ["orders.view_orders"],

    scheduled_deliveries_permissions: ["orders.view_deliveries_list"],
    onroute_deliveries_permissions: ["orders.view_deliveries_list"],
    upcoming_deliveries_permissions: ["orders.view_deliveries_list"],
    incomplete_deliveries_permissions: ["orders.view_deliveries_list"],

    pending_payments_permissions: ["orders.view_payments_list"],
    processed_payments_permissions: ["orders.view_payments_list"],
    manual_statements_permissions: "orders.generate_ordersstatement",
    automated_statements_permissions: ["orders.view_statementemails_list", "orders.view_statementemaildetails_list"],
    credit_note_permissions:["orders.add_creditnote"],

    warehouses_permissions: ["inventory.add_warehouse", "inventory.change_warehouse", "inventory.view_warehouse_list"],
    record_shipment_permissions: ["inventory.add_shipment"],
    shipments_permissions: ["inventory.view_shipment_list", "inventory.change_shipment"],

    add_product_permissions: ["inventory.add_product"],
    products_permissions: ["inventory.view_product_list", "inventory.change_product"],
    stock_permissions: ["inventory.view_stocks_list", "inventory.change_shipmentsstockbalance", "inventory.add_stockadjustment"],
    adjusted_stock_permissions: ["inventory.view_stockadjustment_list"],

    create_sales_profile_permissions: ["feedback.add_feedback"],
    sales_profile_permissions: ["feedback.change_feedback", "feedback.view_feedback_list"],
    add_customer_permissions: ["institution.add_institutions"],
    all_customers_permissions: ["institution.change_institutions", "institution.view_institutions_list"],

    turnover_reports_permissions: [],
    sales_reports_permissions: [],
    orders_and_deliveries_reports_permissions: [],
    finance_reports_permissions: [],
    stock_reports_permissions: [],
    customers_reports_permissions: [],

    add_staff_permissions: ["account.add_users", "account.add_userprofiles"],
    staff_permissions: ["account.view_users_list", "account.view_userprofiles", "account.change_users", "account.change_userprofiles"],
    automated_tasks_permissions: [],
    user_settings_permissions: ["auth.add_group", "auth.change_group", "auth.view_group", "auth.view_permission",
        "institution.view_institution_types_list", "institution.add_institutiontypes", "institution.change_institutiontypes",
        "institution.view_tiers_list", "institution.add_tier", "institution.change_tier"],
    system_settings_permissions: ["institution.view_zones_list", "institution.add_zones", "institution.change_zones",
    "orders.view_timezones_list", "orders.add_timezones", "orders.change_timezones",
    "orders.view_zonedays_list", "orders.add_zonedays", "orders.delete_zonedays",
    "orders.add_publicholidays", "orders.change_publicholidays", "orders.view_publicholidays_list", "orders.delete_publicholidays"],

    cancel_order_permission: "orders.change_ordersstatus_cancel",
    change_order_status_permission: "orders.change_ordersstatus",
    cancel_sample_order_permission: "orders.change_sampleordersstatus",
    change_sample_order_status_permission: "orders.change_sampleordersstatus_cancel",
    view_single_order_sample_permission: "orders.view_sampleorders",
    view_single_order_permission: "orders.view_orders",
    change_order_payment_status_permission: "orders.change_orderspayment",
    mark_order_as_paid_permission: "orders.add_payments",
    mark_order_as_deposited_permission: "orders.add_orderdeposits",
    view_email_statement_details: "orders.view_statementemaildetails",
    generate_order_invoice_permission: "orders.generate_ordersinvoice",
    generate_order_delivery_note_permission: "orders.generate_ordersdeliverynote",
    order_add_warehouse_permission: "orders.select_orderswarehouse",
    ignore_order_timezone_permission: "orders.ignore_orderstimezone",
    change_order_shipment_permission: "orders.change_orderitemsshipments",
    change_order_item_status_permission: "orders.change_orderitemsstatus",
    send_warehouse_email_permission: "orders.send_orderswarehouseemail",
    set_order_surcharge_permission: "orders.set_orderssurchargepercentage",
    delete_order_surcharge_permission: "orders.delete_orderssurchargepercentage",
    delete_order_item_permission: "orders.delete_orderitems",
    change_order_item_permission: "orders.change_orderitems",
    add_order_discount_permission: "orders.add_orderdiscounts",
    edit_order_discount_permission: "orders.change_orderdiscounts",
    delete_order_discount_permission: "orders.delete_orderdiscounts",
    add_order_item_discount_permission: "orders.add_orderitemdiscounts",
    change_order_item_discount_permission: "orders.change_orderitemdiscounts",
    generate_ordersinvoice: "orders.generate_ordersinvoice",
    generate_ordersdeliverynote: "orders.generate_ordersdeliverynote",

    edit_shipment_permission: "inventory.change_shipment",
    add_warehouse_permission: "inventory.add_warehouse",
    edit_warehouse_permission: "inventory.change_warehouse",
    view_single_warehouse_permission: "inventory.view_warehouse",
    move_stock_permission: "inventory.change_shipmentsstockbalance",
    adjust_stock_permission: "inventory.add_stockadjustment",

    edit_product_permission: "inventory.change_product",
    view_single_product_permission: "inventory.view_product",

    view_single_sales_profile_permission: "feedback.view_feedback",
    edit_sale_profile_permission: "feedback.change_feedback",
    add_sales_profile_comment_permission: "feedback.add_thread",
    add_sales_profile_visit_permission: "feedback.add_salesrollcall",
    add_sales_profile_turnover_permission: "feedback.add_turnover",
    add_sales_profile_ownership_permission: "feedback.add_feedbackownership",

    view_single_customer_permission: "institution.view_institutions",
    edit_customer_profile: "institution.change_institutions",
    add_branch_permission: "institution.add_branches",
    edit_branch_permission: "institution.change_branches",
    view_single_branch_permission: "institution.view_branches",

    view_single_user_permission: "account.view_users",
    edit_user_permission: "account.change_users",
    edit_user_profile_permission: "account.change_userprofiles",
    view_single_user_permission_details_permission: "auth.view_permission",

    add_user_role_permission: "auth.add_group",
    edit_user_role_permission: "auth.change_group",
    view_single_user_role_permission: "auth.view_group",
    view_single_user_role_permission_details_permission: "auth.view_permission",
    remove_permission_from_role_permission: "account.delete_rolepermission",
    remove_user_from_role_permission: "account.delete_userrole",
    remove_widget_from_role_permission: "account.delete_rolewidget",

    add_customer_type_permission: "institution.add_institutiontypes",
    edit_customer_type_permission: "institution.change_institutiontypes",

    add_customer_tier_permission: "institution.add_tier",
    edit_customer_tier_permission: "institution.change_tier",

    add_delivery_zone_permission: "institution.add_zones",
    edit_delivery_zone_permission: "institution.change_zones",

    add_timezone_permission: "orders.add_timezones",
    edit_timezone_permission: "orders.change_timezones",

    add_day_zone_permission: "orders.add_zonedays",
    delete_day_zone_permission: "orders.delete_zonedays",

    add_holiday_permission: "orders.add_publicholidays",
    edit_holiday_permission: "orders.change_publicholidays",
    delete_holiday_permission: "orders.delete_publicholidays",

    add_order_date_changes_permission: "orders.add_orderdatechanges"


});
